import { useEffect, useMemo, useState } from 'react';
import { useSiteContext, useTranslation } from '@eti/providers';
import unavailableIcon from '@eti/assets/icons/seating-buttons/default/seatButton-unavailable.svg?url';
import { getSeatIconUrl } from '../utils/getSeatIconUrl';
import { getSeatCharacteristicLabels } from '../components/cabin/seatCharacteristicText';
export const useSeatCharacteristicDisplay = (characteristic, isUnavailable) => {
  const {
    brand
  } = useSiteContext();
  const {
    t
  } = useTranslation();
  const priceFromLabel = t('Product.SeatMap.Characteristic.PriceFrom.Text');
  const [iconUrl, setIconUrl] = useState();
  useEffect(() => {
    let isMounted = true;
    const loadIcon = async () => {
      try {
        if (isUnavailable) {
          if (isMounted) {
            setIconUrl(unavailableIcon);
          }
        } else if (characteristic) {
          const url = await getSeatIconUrl(brand.code, characteristic);
          if (isMounted) {
            setIconUrl(url);
          }
        }
      } catch (e) {
        console.error(e); // oxlint-disable-line no-console
      }
    };
    loadIcon();
    return () => {
      isMounted = false;
    };
  }, [brand, characteristic, isUnavailable]);
  const [label, description] = useMemo(() => getSeatCharacteristicLabels(characteristic, isUnavailable, t), [characteristic, isUnavailable, t]);
  return {
    iconUrl,
    label,
    description,
    priceFromLabel
  };
};
//# sourceMappingURL=useSeatCharacteristicDisplay.js.map